
import { Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';

export class CuratorStyleFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    styleType: StyleTypesApiEnum = StyleTypesApiEnum.COVERAGE_CURATOR;
    allowExpertMode?: boolean = true;
    changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[];

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[]
    ) {
        this.fieldComponent = fieldComponent;
        this.property = 'styles';
        this.changeDefaultStyleStateOptions = changeDefaultStyleStateOptions;
    }
}
